module.exports = __webpack_public_path__ + "static/media/NZ.ad990fc1.png";